export const SellarIconGradient = ({ size = 1 }: { size?: number }) => {
  return (
    <img
      src="https://sellar.imgix.net/sellar-image-assets/sellar-logo-gradient.svg"
      width={20 * size}
      height={20 * size}
      className="min-h-5 min-w-5"
    />
  );
};
